import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';

export default class YearsRequest extends GenericRequest {

    constructionId;

    constructor(constructionId = null) {
        super(METHOD_POST, ApiEndpoints.MONTLY_YEARS);

        this.constructionId = constructionId;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.constructionId ) request.criteria.construction_id = this.constructionId;
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/ws/YearsRequest.js